var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"payment-method-card-logo"},[_c('img',{attrs:{"height":"40","src":_vm.logo,"alt":"Card logo"}})])}
var staticRenderFns = []

export { render, staticRenderFns }